var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C9.2179 22.5 6.68852 21.418 4.80971 19.6518L19.6518 4.80971C21.418 6.68852 22.5 9.2179 22.5 12ZM3.79173 18.5485L18.5485 3.79173C16.753 2.35747 14.4767 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 14.4767 2.35747 16.753 3.79173 18.5485ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#3E3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionIcon);
export default __webpack_public_path__ + "static/media/unionIcon.bedd47a303cac99d5b006b49729591b0.svg";
export { ForwardRef as ReactComponent };